// http://stackoverflow.com/a/27691108
/** Expects `?` as first character of querystring argument. Returns empty object if `qs` parameter is undefined. */
export function qsToObject(qs) {
  if (!qs) {
    return {};
  }
  var hashes = qs.slice(qs.indexOf('?') + 1).split('&');
  var params = {};
  hashes.map(function (hash) {
    var param = hash.split('=');
    var key = param.shift();
    var val = param.join('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
}
export function objectToQs(params) {
  return Object.keys(params).map(function (k) {
    return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(params[k]));
  }).join('&');
}